//-------------------------------------------------------------------
// Our Dishes
//-------------------------------------------------------------------

/* global jQuery */

const $         = jQuery;   // jQuery loaded via WordPress enqueue process
const Isotope   = require('isotope-layout');
const qs        = require('../utilities/querystring');

// Track static values
const SIZE_RELATED_FILTERS = [
    '.single-serve', 
    '.family', 
    '.large-family',
    '.party',
    '.snack'
];

// References to our groups
let $groupSig = null,   // Signature group
    $groupOrg = null;   // Organic group

// References to our Isotope instances
let isoSig = null,
    isoOrg = null;

// Store a reference to our menu items as well
let $dishesLinks = null;

function initProductGrids() {
    isoSig = new Isotope('.dishes-group--signature .dishes-group__list', {
        getSortData: {
            variety: '[data-variety]',
            groupOrder: '[data-group-order]'
        },
        itemSelector: '.dishes-group__item',
        percentPosition: true,
        layoutMode:'fitRows',
        masonry: {
            columnWidth: '.dishes-group__item-sizer'
        }
    });
    isoOrg = new Isotope('.dishes-group--organic .dishes-group__list', {
        itemSelector: '.dishes-group__item',
        percentPosition: true,
        layoutMode: 'fitRows',
        masonry: {
            columnWidth: '.dishes-group__item-sizer'
        }
    });

}

/**
 * Set up product links to grab the current filter size (if one has been chosen) and 
 * append it to the URL.
 */
function initProductLinks() {
    $('.dishes-group__link').click((event) => {
        event.preventDefault();
        let link = $(event.currentTarget).attr('href');
        let currFilter = $dishesLinks.filter('.is-active').data('filter');
        if ($.inArray(currFilter, SIZE_RELATED_FILTERS) >= 0) {
            // A size-related filter is currently active -- let's tag
            // the URL with the value
            // NOTE: The filter names all start with a '.'  -- let's 
            // remove that when assigning the query param
            link += '?size=' + currFilter.substr(1);
        }
        window.location = link;
    });
}

function initDishesFilterMenu() {
    $dishesLinks = $('.dishes-menu__link');

    $dishesLinks.click((event) => {
        event.preventDefault();
        let filterType = $(event.target).data('filter');
        filterGrids(filterType);
    });
}

function filterGrids(filterType) {

    // Save original/raw filterType to identify and highlight active menu item.
    var activeMenuItem = filterType;

    if (history.pushState) {
        var filterSlug = filterType.substring(1, filterType.length);
        var newUrl = window.location.origin + window.location.pathname + '?filter=' + filterSlug;
        if (filterSlug == '') {
            newUrl = window.location.origin + window.location.pathname;
        }
        window.history.pushState({path:newUrl},'',newUrl);
    }

    // If showing Calzones, include Mini Calzones also.
    // The "Mini Calzones" subhead has class .mini-calzones.
    // Show .mini-calzones in a bloc via sortBy.
    // Use existing "Signature" heading text for "Calzones".
    // console.log('FILTER TYPE: '+filterType);
    if ($dishesLinks.parent().find(`[data-filter='${filterType}']`).hasClass('is-active')) {
        return;
    }
    if (filterType != '.calzones') {
        $('.dishes-group--signature h2.dishes-group__subhead.signature').css('display','inline-block');
    }
    if (filterType == '.calzones') {
        filterType = '.calzones, .mini-calzones';
        isoSig.arrange({ filter: filterType, sortBy: 'variety' });
        $('.dishes-group--signature h2.dishes-group__subhead.signature').css('display','none');
        var timeoutID = window.setTimeout(
            function() {
                $('.dishes-group--signature h2.dishes-group__subhead.signature').css('display','none');
            }, 100);
        // $('.dishes-group--signature .dishes-group__subhead.signature').text('Calzones');

    // If showing Single Serve products, show "Gourmet Bowls" as its own section.
    // Restore "Signature" if coming from Calzones.
    } else if (filterType == '.single-serve') {
        filterType = '.gourmet-bowls, .single-serve';
        isoSig.arrange({ filter: filterType, sortBy: 'variety' });
        $('.dishes-group__item gourmet-bowls.subhead').css('display','list-item');
        // $('.dishes-group--signature .dishes-group__subhead.signature').text('Signature');

    // If showing Gourmet Bowls, hide .subhead.
    // Restore "Signature" if coming from Calzones.
    } else if (filterType == '.gourmet-bowls') {
        filterType = filterType + ':not(.subhead)';
        isoSig.arrange({ filter: filterType, sortBy: 'original-order' });
        $('.dishes-group--signature .dishes-group__subhead.signature').text('Signature');

    // If showing Made with Organic products, hide .subhead without display:none.
    // Otherwise, if next filter is Gourmet Bowls or Calzones, .subhead height isn't counted.
    } else if (filterType == '.organic') {
        isoSig.arrange({ filter: filterType, sortBy: 'original-order' });
        // Style .subhead so that it takes up space when isotope arranges products on next fliter click.
        var timeoutID = window.setTimeout(
            function() {
                $('.dishes-group__item.subhead').css('opacity','0');
                $('.dishes-group__item.subhead').css('display','list-item');
                $('.dishes-group__item.subhead h2').css('display','inline-block');
            }, 500);

    // If showing All products, exclude "Mini Calzones" label via class .subhead.
    // Show in original (alphabetical) order.
    // Restore "Signature" heading text.
    // } else if (filterType == '*') {
    //     filterType = filterType + ':not(.subhead)';
    //     isoSig.arrange({ filter: filterType, sortBy: 'original-order' });
    //     $('.dishes-group--signature .dishes-group__subhead.signature').text('Signature');

    // If showing All products, show "Gourmet Bowls", "Calzones", "Mini Calzones" as own sections.
    // Restore "Signature" if coming from Calzones.
    } else if (filterType == '*') {
        filterType = '.gourmet-bowls, .calzones, .mini-calzones, *';
        isoSig.arrange({ filter: filterType, sortBy: ['groupOrder','variety'] });
        $('.dishes-group__item gourmet-bowls.subhead').css('display','list-item');
        $('.dishes-group--signature .dishes-group__subhead.signature').text('Signature');

    // If showing anything else, filter normally.
    // No other filter will pull in Calzones, Mini Calzones.
    // Restore "Signature" heading text.
    } else {
        isoSig.arrange({ filter: filterType });
        // $('.dishes-group--signature .dishes-group__subhead.signature').text('Signature');
    }

    // Made with Organic products.
    isoOrg.arrange({ filter: filterType });

    // Adjust visibility of section header and top border of SIGNATURE group
    adjustGroupHeader(isoSig.filteredItems.length, $groupSig);

    // Adjust visibility of section header and top border of ORGANIC group
    adjustGroupHeader(isoOrg.filteredItems.length, $groupOrg);
    
    // Set the active menu item
    setActiveMenuItem(activeMenuItem);
}

/**
 * Adjust visibility of section header and top border of group
 */
function adjustGroupHeader(visItemCount, $groupRef) {
    if (visItemCount) {
        // At least one item in this group is visible - make sure heading is visible
        if ($groupRef.hasClass('js-no-results')) {
            $groupRef.removeClass('js-no-results');
            $groupRef.find('h2').slideDown();
        }
    } else {
        // No items are visible
        if (!$groupRef.hasClass('js-no-results')) {
            $groupRef.addClass('js-no-results');
            $groupRef.find('h2').slideUp();
        }
    }
}


function setActiveMenuItem(filterType) {
    $dishesLinks.removeClass('is-active');
    $dishesLinks.parent().find(`[data-filter='${filterType}']`).addClass('is-active');
}

/**
 * Check to see if any filter request came in on the query string.
 */
function checkQueryParams() {
    let rawFilterType = qs.getParam('filter');
    if ((rawFilterType !== undefined) && (rawFilterType !== null) && (rawFilterType !== '')) {
        filterGrids('.' + rawFilterType);
    } else {
        // Select all
        filterGrids('*');
    }
}

exports.init = function () {
    // Assing our groups
    $groupSig = $('.dishes-group--signature');
    $groupOrg = $('.dishes-group--organic');

    initProductGrids();
    initProductLinks();
    initDishesFilterMenu();
    checkQueryParams();
};